import { stepConfigItem } from './types';
import { DietIdEnum } from '@front-activerse/common-components';

const stepsSchemaPl: stepConfigItem[] = [
  { id: 'sex', slug: 'sex' },
  { id: 'dateOfBirth', slug: 'birth-date', shouldBackendValidate: true },
  { id: 'heightValue', slug: 'height', shouldBackendValidate: true },
  {
    id: 'weightValue',
    slug: 'weight',
    shouldBackendValidate: true,
  },
  {
    id: 'dietMode',
    slug: 'diet-mode',
    fork: {
      chooseChild: (state: { dietMode: string }) =>
        state.dietMode !== 'stabilization' ? 'goalWeight' : 'activityLevel',
      children: {
        goalWeight: [
          { id: 'goalWeightValue', slug: 'goal-weight', shouldBackendValidate: true },
          { id: 'spontaneousActivityLevel', slug: 'spontaneous-activity-level' },
          { id: 'activityLevel', slug: 'activity-level' },
          {
            id: 'dietType',
            slug: 'diet-type',
            fork: {
              chooseChild: (state: { dietType: any }) => {
                switch (state.dietType) {
                  case DietIdEnum.DIET_ID_HIGH_PROTEIN:
                    return 'oxyHighProtein';
                  case DietIdEnum.DIET_ID_HIGH_PROTEIN2:
                    return 'oxyInstant';
                  case DietIdEnum.DIET_ID_ANTY_JOJO:
                    return 'oxyHighProtein';
                  case DietIdEnum.DIET_ID_SIMPLE:
                    return 'oxySimple';
                  case DietIdEnum.DIET_ID_SIMPLE_ANTY_JOJO:
                    return 'oxySimple';
                  case DietIdEnum.DIET_ID_INSTANT:
                    return 'oxyInstant';
                  default:
                    return 'oxyHighProtein';
                }
              },
              children: {
                oxyHighProtein: [
                  {
                    id: 'dietLevel',
                    slug: 'diet-level',
                  },
                  {
                    id: 'dietVariant',
                    slug: 'diet-variant',
                  },
                  { id: 'summary', slug: 'summary' },
                ],
                oxySimple: [
                  {
                    id: 'dietLevel',
                    slug: 'diet-level',
                  },
                  { id: 'summary', slug: 'summary' },
                ],
                oxyInstant: [{ id: 'summary', slug: 'summary' }],
              },
            },
          },
        ],
        activityLevel: [
          { id: 'spontaneousActivityLevel', slug: 'spontaneous-activity-level' },
          { id: 'activityLevel', slug: 'activity-level' },
          {
            id: 'dietType',
            slug: 'diet-type',
            fork: {
              chooseChild: (state: { dietType: any }) => {
                switch (state.dietType) {
                  case DietIdEnum.DIET_ID_HIGH_PROTEIN:
                    return 'oxyHighProtein';
                  case DietIdEnum.DIET_ID_HIGH_PROTEIN2:
                    return 'oxyInstant';
                  case DietIdEnum.DIET_ID_ANTY_JOJO:
                    return 'oxyHighProtein';
                  case DietIdEnum.DIET_ID_SIMPLE:
                    return 'oxySimple';
                  case DietIdEnum.DIET_ID_SIMPLE_ANTY_JOJO:
                    return 'oxySimple';
                  case DietIdEnum.DIET_ID_INSTANT:
                    return 'oxyInstant';
                  default:
                    return 'oxyHighProtein';
                }
              },
              children: {
                oxyHighProtein: [
                  {
                    id: 'dietLevel',
                    slug: 'diet-level',
                  },
                  {
                    id: 'dietVariant',
                    slug: 'diet-variant',
                  },
                  { id: 'summary', slug: 'summary' },
                ],
                oxySimple: [
                  {
                    id: 'dietLevel',
                    slug: 'diet-level',
                  },
                  { id: 'summary', slug: 'summary' },
                ],
                oxyInstant: [{ id: 'summary', slug: 'summary' }],
              },
            },
          },
        ],
      },
    },
  },
];

export default stepsSchemaPl;
